"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_ordermade_error.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailError = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * UpdateOrdermadeProductDetailのエラー詳細（ConnectErrorのdetailsで返す）
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason
 */
var EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason;
(function (EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason[EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason["EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED";
    /**
     * 申請中の商品詳細は編集できない
     *
     * @generated from enum value: EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE = 1;
     */
    EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason[EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason["EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE"] = 1] = "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE";
})(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason || (exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason, "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason", [
    { no: 0, name: "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_SUBMITTED_PRODUCT_DETAIL_NOT_EDITABLE" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailError
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason reason = 1;
         */
        this.reason = EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason.EMS_ORDERMADE_SERVICE_UPDATE_ORDERMADE_PRODUCT_DETAIL_ERROR_REASON_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailError, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailError = EMSOrdermadeServiceUpdateOrdermadeProductDetailError;
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailError";
EMSOrdermadeServiceUpdateOrdermadeProductDetailError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeServiceUpdateOrdermadeProductDetailErrorReason) },
]);
//# sourceMappingURL=ems_ordermade_error_pb.js.map